import axios from 'axios';
import { store } from './../App';
// import { useHistory } from 'react-router-dom';

// const routeHistory = useHistory();

axios.interceptors.request.use(
    config => {
        if(!(!!config.params && !config.params.loader) && !(!!config.body && !config.body.loader)) {
            store.dispatch({
                type: "LOADER",
                payload: {
                    loader: true
                }
            });
        }
        config.headers = {
            "X-API-KEY": store.getState().loginReducer.token
        }
        return config;
    }, error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if(!(!!response.config.params && !response.config.params.loader) && !(!!response.config.body && !response.config.body.loader)) {
            store.dispatch({
                type: "LOADER",
                payload: {
                    loader: false
                }
            });
        }
        return response;
    }, error => {
        store.dispatch({
            type: "ERROR",
            payload: {
                error
            }
        });
        return Promise.reject();
    }
);

class axiosInterceptor {

    get(url, body) {
        return axios.get(url, body);
    }

    post(url, body, config) {
        return axios.post(url, body, config);
    }

    put(url, body, config) {
        return axios.put(url, body, config);
    }

    patch(url, body, config) {
        return axios.patch(url, body, config);
    }

    delete(url, body, config) {
        return axios.delete(url, body, config);
    }
}

export default axiosInterceptor.prototype;